<template>
  <input-widget :label="label" :model="model" :disabled="disabled" :readonly="readonly" :rules="rules"
                :size="size" :input-id="inputId" :attribute="attribute" :prepend="computedCurrency"
                :hint="hint" @input="onInput" type="number" :append-question="appendQuestion"
                :placeholder="placeholder" :title-hint="titleHint" :step="step"/>
</template>

<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import {uuid} from 'vue-uuid';

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CurrencyInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      placeholder: {
        type: [String, Boolean],
        default: null
      },
      attribute: {
        type: String,
        required: true
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      currency: {
        type: String,
        default: ''
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      size: {
        type: String,
        default: 'md'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      inputId: {
        type: String,
        default() {
          return `${this.attribute}-${uuid.v4()}`
        }
      },
      appendQuestion: {
        type: String,
        default: null
      },
      titleHint: {
        type: [Boolean, String],
        default: false
      },
      step: {
        type: [String, Number],
        default: null,
        required: false
      },
    },
    computed: {
      ...globalMapState({
        currentBranchCurrency: state => state.currentBranch.currency.symbol,
      }),
      computedCurrency() {
        return this.currency || this.currentBranchCurrency;
      }
    },
    methods: {
      onInput($event) {
        this.$emit('input', $event)
      }
    }
  }
</script>

<style scoped>

</style>
